<template>
  <ModalDialog
    ref="dialog"
    title="Xero Relink Contact"
    icon="fa-id-card-alt"
    :submitting="submitting"
    submitTitle="Relink"
    :submitDisabled="submitDisabled"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="xeroForm" :labelColumnSize="3">
      <LoadingPanel ref="loadingPanel" @update="loading = $event" :loadingError="loadingError" />

      <div v-show="!loading && !loadingError">
        <NotificationBar type="warning">
          <NotificationBarTitle>This will relink the Synergy Contact with a specific Xero Contact</NotificationBarTitle>
            <ul>
              <li>All invoices / payments / credit notes already synced with Xero will not change contact in Xero</li>
              <li>Only future invoices / payments / credit notes will be synced to the new Xero contact</li>
            </ul>
        </NotificationBar>

        <FormRow label="Xero Contact">
          <FormSearchableSelect :options="xeroContactLookup" v-model="selectedXeroContactId" />
        </FormRow>
      </div>

    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'
import IntegrationXeroAPIService from '@/integrations/xero/services/apiService'

export default {
  name: 'XeroContactRelinkDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {
    contactId: Number,
    xeroContactID: String    
  },
  data() {
    return {
      xeroForm: {},
      loading: true,
      loadingError: '',
      submitting: false,

      selectedXeroContactId: this.xeroContactID || '',
      xeroContactList: []
    }
  },
  created() {
  },
  mounted() {
  },
  computed: {
    xeroContactLookup() {
      return this.xeroContactList.map(xeroContact => {
        return {
          name: xeroContact.name,
          value: xeroContact.contactID
        }
      })
    },
    submitDisabled() {
      return this.xeroContactLookup.find(item => item.value == this.selectedXeroContactId) == null
    }
  },
  methods: {
    show() {
      // Reset form
      this.xeroForm = {}
      this.submitting = false

      this.requestData()

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      var xeroService = new IntegrationXeroAPIService(this.$api)

      this.submitting = true
      this.xeroForm = this.clearFormResponse()
      
      let relinkData = {
        xeroContactID: this.selectedXeroContactId
      }

      xeroService.relinkContact(this.contactId, relinkData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
        this.successToast('Xero Contact Relinked')
      })
      .catch(err => {
        this.xeroForm = this.processFormResponse(err)
      })
      .finally(() => {
        this.submitting = false
      })

    },
    requestData() {
      var xeroService = new IntegrationXeroAPIService(this.$api)

      this.$refs.loadingPanel.startLoading()
      xeroService.getXeroContactList()
      .then(response => {
        this.xeroContactList = response.data
      })
      .catch(err => {
        this.$refs.loadingPanel.setError('Error accessing Xero contact list', err)
      })
      .finally(() => {
        this.$refs.loadingPanel.finishedLoading()
      })
    }
  }
}
</script>
